/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListShadowMCPInventory } from "../funcs/accessListShadowMCPInventory.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListShadowMCPInventoryResult } from "../models/components/listshadowmcpinventoryresult.js";
import {
  ListShadowMCPInventoryRequest,
  ListShadowMCPInventorySecurity,
} from "../models/operations/listshadowmcpinventory.js";
import { unwrapAsync } from "../types/fp.js";
export type ShadowMCPInventoryQueryData = ListShadowMCPInventoryResult;

export function prefetchShadowMCPInventory(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListShadowMCPInventoryRequest,
  security?: ListShadowMCPInventorySecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildShadowMCPInventoryQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildShadowMCPInventoryQuery(
  client$: GramCore,
  request: ListShadowMCPInventoryRequest,
  security?: ListShadowMCPInventorySecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ShadowMCPInventoryQueryData>;
} {
  return {
    queryKey: queryKeyShadowMCPInventory({
      projectId: request.projectId,
      limit: request.limit,
      cursor: request.cursor,
      gramSession: request.gramSession,
    }),
    queryFn: async function shadowMCPInventoryQueryFn(
      ctx,
    ): Promise<ShadowMCPInventoryQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListShadowMCPInventory(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyShadowMCPInventory(
  parameters: {
    projectId: string;
    limit?: number | undefined;
    cursor?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listShadowMCPInventory", parameters];
}
